import React from "react";
import Container from "@ui/container";
import { LogoCsWithSelect } from "@ui/logo";
const SelectLogoWidget = (props) => {
    return (
        <Container>
            <LogoCsWithSelect className="w-2/4 max-w-[145px] md:max-w[160px] min-w-[120px]" />
        </Container>
    );
};

export default SelectLogoWidget;
